import React from 'react'
import UI5ControlButton from "../../../../../layout/app-controls/buttons/button/button"

type Props = {
    title?  : string
    icon?   : string

    onClose?: {(e:any):void}
}

export default function PreferencesHeader(props:Props) {

    const title = (props.title)?props.title:"Settings"
    const iconClasses = Classes("header-icon ui5-ico-16", (props.icon)?props.icon:"i5-settings")

    return (
        <div className="f-header">
            <div className="title">
                <div className={iconClasses}/>
                {title}
            </div>

            <div className="right">
                <UI5ControlButton size="24" iconClass="ui5-icon-close" fontSize="14" className="ui5-color-system-black" onClick={props.onClose} />
            </div>
        </div>
    )
}